import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
  },
  containerLeft: {
    flex: 3,
  },
  containerRight: {
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});
